import { getLatestScrape } from 'utils/scrapeUtils';
import initialState from './initial';
import * as types from '../constants/scrape';
import * as fileTypes from '../constants/file';

const SrapeReducer = (state = initialState.scrapeData, action) => {
    const { type, payload } = action;
    switch (type) {
        case fileTypes.FILES_FETCH_SUCCESS: {
            const scrapes = payload.documents.filter(x => x.fileType === 'PensionsInfoFile' && x.content && x.content.profil).map(x => ({ ...x.content, fileId:x.fileId, createdAt: x.createdAt }));
            const latestScrape = getLatestScrape(scrapes);
            return { ...state, isFetching: false, scrapes, latestScrape, fetched: true };
        }
        case fileTypes.FILE_DELETE_SUCCESS: {
            return { ...state, scrapes: state.scrapes.filter(x => x.fileId !== payload.fileId) };
        }

        default:
            return state;
    }
};
export default SrapeReducer;
